<template>
    <div :style="`position:relative; background-color: #DCDFE6; display: block !important; height:1px; width:100%; margin:${margin}px 0`"></div>
</template>

<script>
    export default {
        name: "MyDivider",
        props: {
            // margin 可以同时上下的间距
            margin: {
                type: Number,
                default: 30
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/commons/MyDivider.vue